module.exports = __webpack_public_path__ + "static/media/icon_import_fail_result.2d40fca0.svg";